
const ContractRoutes = [
    {
        path: '',
        name: 'contract-index',
        component: () => import("@/views/overview.vue")
    },
    {
        path: 'add',
        name: 'contract-add',
        component: () => import("@/components/contract/add.vue")
    },
    {
        path: 'form',
        name: 'form-contract',
        component: () => import("@/components/contract/form.vue")
    },
    {
        path: 'ai-upload',
        name: 'contract-ai-upload',
        component: () => import("@/components/contract/ai-upload.vue")
    }
];
export default ContractRoutes
